// extracted by mini-css-extract-plugin
module.exports = {"FeedbackPageWrapper":"styles_FeedbackPageWrapper__ts9DJ","FeedbackPageForm":"styles_FeedbackPageForm__3PmTA"};